var prices = [];
var departureMinPrices = [];
var returnMinPrices = [];
var depMinMaxPrice=[];
var retMinMaxPrice=[];

var bestPrice = {
    searchText : null,
    graphSourceId : null,
    direction: 1
};

var type_departure = 1;
var type_return = 2;

function getSearchMinPriceData() {
    $("#departureAvailableTitle").hide();
    $("#returnAvailableTitle").hide();

    var dateFormat = 'dd.mm.yy';
    var departureDateStr = $("#departureDate").val();
    var departureDate = $.datepicker.parseDate(dateFormat, departureDateStr.substr(0,10));

    var now = new Date();

    var start = new Date(departureDate.getFullYear(), departureDate.getMonth(), departureDate.getDate()-3);
    var end = new Date(departureDate.getFullYear(), departureDate.getMonth(), departureDate.getDate()+3);

    start = now.getTime() > start.getTime() ? now : start;
    var departureStart = $.datepicker.formatDate(dateFormat, start);
    var departureEnd = $.datepicker.formatDate(dateFormat, end);

    var isRoundTrip = bestPrice.direction == 2 ;

    var returnStart = '';
    var returnEnd = '';
    if(isRoundTrip){
        var returnDateStr = $("#returnDate").val();
        var returnDate = $.datepicker.parseDate(dateFormat, returnDateStr.substr(0,10));

        start = new Date(returnDate.getFullYear(), returnDate.getMonth(), returnDate.getDate()-3);
        end = new Date(returnDate.getFullYear(), returnDate.getMonth(), returnDate.getDate()+3);

        start = now.getTime() > start.getTime() ? now : start;
        returnStart = $.datepicker.formatDate(dateFormat, start);
        returnEnd = $.datepicker.formatDate(dateFormat, end);
    }

    var fromAirportId = $("[name=fromAirportId]").val();
    var toAirportId = $("[name=toAirportId]").val();

    var fromAirport = $("[name=fromAirport]").val();
    var toAirport = $("[name=toAirport]").val();

        $.ajax(
            {
                type : 'POST',
                url : '/getSearchMinPriceDataList',
                dataType : 'json',
                async:true,
                data : {
                    departureStart : departureStart,
                    departureEnd : departureEnd,
                    returnStart : returnStart,
                    returnEnd : returnEnd,
                    fromAirportId: fromAirportId,
                    toAirportId : toAirportId,
                    fromAirport : fromAirport,
                    toAirport : toAirport
                },
                success : function(response) {
                    if(response.success) {
                        departureMinPrices = departureMinPrices
                            .concat(response.departureMinPrices
                                .map(function(item) {
                                    item.price = item.price
                                        .toFixed(0);
                                    return item;
                                }));
                        returnMinPrices = returnMinPrices
                            .concat(response.returnMinPrices
                                .map(function(item) {
                                    item.price = item.price
                                        .toFixed(0);
                                    return item;
                                }));
                        depMinMaxPrice= minMax(departureMinPrices);
                        retMinMaxPrice=minMax(returnMinPrices);
                    }
                }
            })
            .then(function() {
                if (departureMinPrices.length > 0){
                    $("#departureAvailableTitle").show();
                    $.each(departureMinPrices, function( index, value ) {
                        var date = new Date(value.date);
                        var currentItem = ((index+1) == Math.ceil(departureMinPrices.length/2));
                        $("#departureAvailableDates").append(getTemplate(date,currentItem,type_departure));
                    });
                }

                if(returnMinPrices.length > 0){
                    $("#returnAvailableTitle").show();
                    $.each(returnMinPrices, function( index, value ) {
                        var date = new Date(value.date);
                        var currentItem = ((index+1) == Math.ceil(returnMinPrices.length/2));
                        $("#returnAvailableDates").append(getTemplate(date,currentItem,type_return));
                    });
                }

            });
}

function minMax(items) {
    return items.reduce(function(res, val){
        res[0] = ( res[0] === undefined || parseInt(val.price) < res[0] ) ? val.price : res[0]
        res[1] = ( res[1] === undefined || parseInt(val.price) > res[1] ) ? val.price : res[1]
        return res;
    }, []);
}

function getTemplate(date, currentItem, type){
    var currentItemStyle = currentItem ? 'date-box-current' : '';
    var template = '<li class="date-box-item '+currentItemStyle+'"> <button type="button" class="btn btn-link" onclick="searchSelectedDate('+date.getTime()+' , '+type+')"> <div>'+getDateText(date)+'</div> <div><b>'+DateLongNames.day[date.getDay()]+'</b></div> <div>'+bestPrice.searchText+'<i class="fas fa-search"></i></div> </button> </li>';
    return template;
}

function getDateText(date){
    var dateText = date.getDate() > 9 ? date.getDate() : "0" + date.getDate() ;
    dateText += "." + (date.getMonth() > 8 ? parseInt(date.getMonth()+1) : "0" + parseInt(date.getMonth()+1));

    return dateText;
}

function searchSelectedDate(dateMs, type){

    var date = new Date(dateMs);

    var dateFormat = 'dd.mm.yy';
    var dateStr  = $.datepicker.formatDate(dateFormat, date);

    if(type === type_departure) {
        $("#departureDate").val(dateStr);
    }
    else if(type === type_return){
        $('#returnDate').removeAttr("disabled");
        $("#returnDate").val(dateStr);
    }

    if ((type === type_departure && bestPrice.direction !== 2)
        || type === type_return && bestPrice.direction === 2) {
        var source = $("[name=source]").val();
        if (source == null) {
            var url = $("#searchForm").attr("action");
            $("#searchForm").attr("action", url + "?source=" + bestPrice.graphSourceId);
        }

        openFlightLoaderBox();
        $("#searchForm").submit();
    }
}
